import palette from '../palette';
import typography from '../typography';

const MuiToggleButton = {
  styleOverrides: {
    root: {
      ...typography.button,
      '&.Mui-disabled': {
        borderColor: palette._next.primary._states.outlinedBorder,
        color: palette._next.text.disabled,
      },
      '&.Mui-selected': {
        '&:hover': {
          backgroundColor: palette._next.primary._states.hover,
        },
        backgroundColor: palette._next.primary._states.selected,
        borderColor: palette._next.primary.main,
        color: palette._next.primary.main,
      },
      '&:hover': {
        backgroundColor: palette._next.primary._states.hover,
        borderColor: palette._next.primary.main,
      },
      borderColor: palette._next.primary._states.outlinedBorder,
      borderRadius: '4px',
      color: palette._next.primary.main,
      flex: '1 1 0',
      paddingTop: '15px',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    },
  },
};

export default MuiToggleButton;
